// Mobile drawer (hamburger). HTML needs #toggle, #drawer_layer, nav.
// 状態クラス: #toggle.is-active, nav.is-open, #drawer_layer.is-visible, body.is-drawerOpen
// CSS handles fade / slide / scroll-lock. JS は class toggle のみ。
export function initDrawer() {
  const toggle = document.getElementById('toggle');
  const layer = document.getElementById('drawer_layer');
  const nav = document.querySelector('.l-header-nav');
  if (!toggle) return;

  const close = () => {
    toggle.classList.remove('is-active');
    if (layer) layer.classList.remove('is-visible');
    if (nav) nav.classList.remove('is-open');
    document.body.classList.remove('is-drawerOpen');
  };
  const open = () => {
    toggle.classList.add('is-active');
    if (layer) layer.classList.add('is-visible');
    if (nav) nav.classList.add('is-open');
    document.body.classList.add('is-drawerOpen');
  };

  toggle.addEventListener('click', () => {
    toggle.classList.contains('is-active') ? close() : open();
  });
  if (layer) layer.addEventListener('click', close);
  if (nav) {
    nav.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        if (toggle.offsetParent !== null) close();
      });
    });
  }
}
